import * as faceapi from 'face-api.js';

export default {
  data(){
    return {
      faceData : null,
      imageLoaded : false,
      imageWidth : 380,
      debug: false,
      crownData: {
        left : {
          x : 0.13144963,
          y : 0.9702,
        },
        right:{
          x : 0.86486486,
          y : 0.9702,
        },
        aspect: 1.24553571
      },
      glassData: {
        left : {
          x : 0.4116,
          y : 0.4529,
        },
        right:{
          x : 0.592,
          y : 0.4529,
        },
        aspect: 3.43566148
      }
    }
  },
  computed: {
    profilepic() {
      return this.$store.state.assessment.assessment.profilepic;
    },
    isCrown(){
      return this.mode === 'crown';
    }
  },
  mounted() {

    this.getImage().then((img)=>{
      const canvas=this.$refs.canvas;
      canvas.width = this.imageWidth;
      canvas.height = this.imageWidth;
      let ctx = canvas.getContext('2d');
      const scale=this.imageWidth/Math.min(img.width,img.height);
      ctx.drawImage(img,
        0,0,img.width,img.height,
        (canvas.width-img.width*scale)/2, (canvas.height-img.height*scale)/2,
        img.width*scale, img.height*scale
      );
      this.imageLoaded=true;

      return  Promise.all([
        faceapi.nets.faceLandmark68TinyNet.loadFromUri('/weights'),
        faceapi.nets.tinyFaceDetector.loadFromUri('/weights')]).then(() => {
        faceapi.detectAllFaces(canvas, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks(true).then((detections) => {
          if (detections.length > 0) {

            const face = detections[0];
            const landmarks = face.landmarks;

            const leftEye = this.getMean(landmarks.getLeftEye());
            const rightEye = this.getMean(landmarks.getRightEye());
            const angle = this.getAngle(leftEye,rightEye);

            this.faceData = {angle};
            this.faceData.distance=rightEye.x-leftEye.x;
            this.faceData.width=face.detection.box.width;

            if(this.isCrown){
              this.getCrownPosition(landmarks,ctx);
            }else{
              this.getGlassesPosition(landmarks,ctx);
            }
            this.initiateAchievement();
          }else{
            this.initiateAchievement();
          }
        });
      });
    })


  },
  methods: {
    getCrownPosition(landmarks,ctx){
      let leftEye = this.getLeftTop(landmarks.getLeftEyeBrow());
      let rightEye = this.getRightTop(landmarks.getRightEyeBrow());
      let distanceBetweenEyes = Math.sqrt(Math.pow(rightEye.x - leftEye.x,2) + Math.pow(rightEye.y - leftEye.y,2));
      const angle=this.faceData.angle;
      let widthCorr = (this.faceData.width - distanceBetweenEyes)/2;

      leftEye = {
        x: leftEye.x - widthCorr,
        y: leftEye.y + (angle>0?-1:1) * this.getDegTan(angle)*widthCorr,
      };
      rightEye = {
        x: rightEye.x + widthCorr,
        y: rightEye.y + (angle<=0?-1:1) * this.getDegTan(angle)*widthCorr,
      };

      const distAsPerc=this.crownData.right.x - this.crownData.left.x;
      const w = widthCorr + distanceBetweenEyes / distAsPerc;
      const h = w / this.crownData.aspect;
      //distanceBetweenEyes = Math.sqrt(Math.pow(rightEye.x - leftEye.x,2) + Math.pow(rightEye.y - leftEye.y,2));

      if(this.debug){
        ctx.beginPath();
        ctx.arc(leftEye.x,leftEye.y,3,0,2*Math.PI);
        ctx.arc(rightEye.x,rightEye.y,3,0,2*Math.PI);
        ctx.strokeStyle = 'red';
        ctx.stroke();
      }


      const yCorr=(this.crownData.left.y * h);

      const xCorr = this.getDegTan(angle)*yCorr;

      this.faceData = {
        left: {
          x: leftEye.x + ((angle>0?1:-1) * xCorr),
          y: leftEye.y - yCorr
        },
        width: w,
        angle:this.faceData.angle
      };
    },
    getGlassesPosition(landmarks,ctx){
      let leftEye = this.getLeftTop(landmarks.getNose());
      let rightEye = this.getRightTop(landmarks.getNose());

      const distanceBetweenEyes = Math.sqrt(Math.pow(rightEye.x - leftEye.x,2) + Math.pow(rightEye.y - leftEye.y,2));
      const distAsPerc=this.glassData.right.x - this.glassData.left.x;

      const w = distanceBetweenEyes / distAsPerc;
      const h = w / this.glassData.aspect;

      if(this.debug){
        ctx.beginPath();
        ctx.arc(leftEye.x,leftEye.y,3,0,2*Math.PI);
        ctx.arc(rightEye.x,rightEye.y,3,0,2*Math.PI);
        ctx.strokeStyle = 'red';
        ctx.stroke();
      }

      this.faceData = {
        left: {
          x: leftEye.x - (this.glassData.left.x * w),
          y: leftEye.y - (this.glassData.left.y * h)
        },
        width: w,
        angle:this.faceData.angle
      };
    },
    getDegTan(deg){
      return Math.tan(Math.abs(deg) * Math.PI/180);
    },
    getImage() {
      return new Promise((resolve => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          resolve(img);
        };
        img.src = this.profilepic.url;
      }));

    },
    getMean(points){
      let sumX=0;
      let sumY=0;
      const n=(points.length || 1);
      for (let p of points) {
        sumX+=p.x;
        sumY+=p.y;
      }
      return {
        x : sumX/n,
        y : sumY/n,
      }

    },
    getLeftTop(points) {
      let x = null;
      let y = null;
      for (let p of points) {
        if (x === null || p.x < x) {
          x = p.x;
        }
        if (y === null || p.y < y) {
          y = p.y;
        }
      }

      return {x, y};
    },
    getRightTop(points) {
      let x = null;
      let y = null;
      for (let p of points) {
        if (x === null || p.x > x) {
          x = p.x;
        }
        if (y === null || p.y < y) {
          y = p.y;
        }
      }
      return {x, y};
    },
    getAngle(p1,p2){
      return Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI;
    }
  }
}